// extracted by mini-css-extract-plugin
export default {"wrapper":"collapsable-popin_wrapper__HBYEt","card":"collapsable-popin_card__nrcFv","slidingHandle":"collapsable-popin_slidingHandle__lzbqz","rect":"collapsable-popin_rect__vVZ+7"};